<div>
  <div class="bisual-table">
    <div class="bisual-table-container">
      <table mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="is_active">
          <th mat-header-cell *matHeaderCellDef>Estado</th>
          <td mat-cell *matCellDef="let workingContractVariableCondition">
            <span [matTooltip]="workingContractVariableCondition.is_active ? 'Contrato activo' : 'Contrato inactivo'">
              {{ workingContractVariableCondition.is_active ? '✅' : '⌛' }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="start_date">
          <th mat-header-cell *matHeaderCellDef>Inicio</th>
          <td mat-cell *matCellDef="let workingContractVariableCondition">
            @if (dateIsAfterToday(workingContractVariableCondition.start_date)) {
              <mat-form-field appearance="outline" class="nobottom">
                <input
                  matInput
                  [matDatepicker]="picker"
                  [formControl]="formGroups[workingContractVariableCondition.id].controls['start_date']"
                  (dateChange)="saveStartDate(workingContractVariableCondition)"
                  [min]="getMinStartDate(workingContractVariableCondition)"
                  [max]="getMaxStartDate(workingContractVariableCondition)"
                />
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
            } @else {
              {{ formatDate(workingContractVariableCondition.start_date) }}
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="end_date">
          <th mat-header-cell *matHeaderCellDef>Fin</th>
          <td mat-cell *matCellDef="let workingContractVariableCondition">
            <mat-form-field appearance="outline" class="nobottom">
              <input
                matInput
                [matDatepicker]="picker"
                [formControl]="formGroups[workingContractVariableCondition.id].controls['end_date']"
                (dateChange)="saveEndDate(workingContractVariableCondition)"
                [min]="getMinEndDate(workingContractVariableCondition)"
                [max]="getMaxEndDate(workingContractVariableCondition)"
              />
              <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let workingContractVariableCondition">
            <button mat-icon-button [matMenuTriggerFor]="menu">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu" class="compact-menu">
              @if (workingContractVariableCondition.is_active || !canManageVariableConditionsAdminActions) {
                <button mat-menu-item (click)="openWorkingContractVariableConditionDialogComponent(workingContractVariableCondition)">
                  <mat-icon>visibility</mat-icon>
                  Ver
                </button>
              }

              @if (canManageVariableConditionsAdminActions) {
                <button
                  mat-menu-item
                  (click)="openWorkingContractVariableConditionDialogComponent(workingContractVariableCondition)"
                  [disabled]="workingContractVariableCondition.is_active"
                >
                  <mat-icon>edit</mat-icon>
                  Editar
                </button>

                <button
                  mat-menu-item
                  (click)="openDatePickerDialogComponent(workingContractVariableCondition)"
                  [disabled]="!canManageUserContractForm"
                >
                  <mat-icon>content_copy</mat-icon>
                  Clonar
                </button>

                <button
                  mat-menu-item
                  (click)="deleteWorkingContractVariableCondition(workingContractVariableCondition)"
                  [disabled]="workingContractVariableCondition.is_active"
                >
                  <mat-icon>delete</mat-icon>
                  Eliminar
                </button>
              }
            </mat-menu>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </div>
</div>
